import React from "react";
import DatePicker from "../DatePicker";
import useDatePattern from "@/Hooks/useDatePattern";
import { TDatePicker, TRangePicker } from "../DatePicker/interface";

const ZDatePicker: TDatePicker = props => {
	const datePattern = useDatePattern();
	return <DatePicker format={datePattern} {...props} />;
};
const ZRangePicker: TRangePicker = props => {
	const datePattern = useDatePattern();
	return <DatePicker.RangePicker format={datePattern} {...props} />;
};

ZDatePicker.RangePicker = ZRangePicker;

export default ZDatePicker;
